module.exports = __webpack_public_path__ + "static/media/zielony_stres.03ac5460.png";